@if ((useLazyLoad || isLoaded) && !isIncomplete) {
  <wc-wrapper [contentWrapper]="wrapper">
    <sd-blockquote sd-component-wrapper-component
      [sdSpyTarget]="componentUid"
      [quote]="quote"
      [brand]="brandCorner"
      [isLoading]="useLazyLoad && !isLoaded"
    />
  </wc-wrapper>
}
